export default __webpack_public_path__ + "static/media/portfolio-hover-165.74c1e311.jpg";